import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { isNil } from 'lodash';
import { Observable, Subject, of } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-header-dropdown',
  templateUrl: './header-dropdown.component.html',
  styleUrls: ['./header-dropdown.component.scss'],
})
export class HeaderDropdownComponent implements OnInit, OnChanges, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  @Input() items: Observable<any[]> = of([]);
  @Input() buttonToggleText = '';
  @Output() itemsChanged = new EventEmitter();
  @Output() itemSelected = new EventEmitter();
  @Output() searchTermChanged = new EventEmitter(true);

  isDropDownShown = false;
  selectedItem: any = null;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.items.pipe(
      filter((x) => isNil(this.selectedItem),
      takeUntil(this.unsubscribe$))
    ).subscribe((x) => {
      this.selectedItem = x[0];
      this.itemSelected.emit(this.selectedItem);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items']) {
      this.itemsChanged.emit(null);
    }
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  @HostListener('document:click', ['$event']) onDocumentClick($event: Event) {
    if (!this.elementRef.nativeElement.contains($event.target)) {
      this.isDropDownShown = false;
    }
  }

  toggleDropDown = () => (this.isDropDownShown = !this.isDropDownShown);

  selectItem = (item: any) => {
    this.selectedItem = item;
    this.isDropDownShown = false;
    this.itemSelected.emit(item);
  };

  itemSearch = (searchTerm: string) => this.searchTermChanged.emit(searchTerm);
}
